import React from 'react';
import ConfirmEmail from '../../HomePatient2/ConfirmEmail';
import NewCredentials from '../../NewCredentials';
import PatientTemplate from '../../PatientTemplate';
import PatientSignatureCanvas from '../../PatientTemplate/PatientSignatureCanvas';
import PatientQuestionnaire from '../../Questionnaire';
import ReferralSubmission from '../../ReferralSubmission';
import { TelemedicinePage } from '../../Telemedicine';

/**
 * Patient routes available both auth and unauthenticated
 */
const COMMON_ROUTES = {
  '/telemedicine/:id': {
    element: <TelemedicinePage />,
    authenticated: false,
  },
  '/questionnaire/:id/:code/:intern?/:telemedicine?': {
    element: <PatientQuestionnaire />,
    authenticated: false,
  },
  '/new-credentials': {
    element: <NewCredentials />,
    exact: false,
    authenticated: false,
  },
  '/patient-fill/:documentId': {
    element: <PatientTemplate />,
    authenticated: false,
  },
  '/referral-submission': {
    element: <ReferralSubmission />,
    authenticated: false,
  },
  '/draw-signature': {
    element: <PatientSignatureCanvas />,
    authenticated: false,
  },
  '/confirm': {
    element: <ConfirmEmail />,
    exact: false,
    authenticated: false,
  },
};

export default COMMON_ROUTES;
